const objectToQueryString = obj => {
  return Object.keys(obj)
    .map(key => {
      return key === 'cardIds' ? key + '[]=' + obj[key] : key + '=' + obj[key];
    })
    .join('&');
};

export default objectToQueryString;
